'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SortableList.scss');

var layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};

var SortableItemPreview = (_dec = (0, _reactDnd.DragLayer)(function (monitor) {
  return {
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
    itemType: monitor.getItemType()
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SortableItemPreview, _Component);

  function SortableItemPreview() {
    (0, _classCallCheck3.default)(this, SortableItemPreview);
    return (0, _possibleConstructorReturn3.default)(this, (SortableItemPreview.__proto__ || (0, _getPrototypeOf2.default)(SortableItemPreview)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableItemPreview, [{
    key: 'getItemStyles',
    value: function getItemStyles() {
      var currentOffset = this.props.currentOffset;

      if (!currentOffset) {
        return { display: 'none' };
      }

      var _ref = this.layerElement ? this.layerElement.getBoundingClientRect() : {},
          _ref$top = _ref.top,
          top = _ref$top === undefined ? 0 : _ref$top,
          _ref$left = _ref.left,
          left = _ref$left === undefined ? 0 : _ref$left;

      var x = currentOffset.x,
          y = currentOffset.y;

      var transform = 'translate(' + (x - left) + 'px, ' + (y - top) + 'px)';

      return {
        transform: transform,
        WebkitTransform: transform
      };
    }
  }, {
    key: 'getLayerElement',
    value: function getLayerElement(element) {
      this.layerElement = element;
    }
  }, {
    key: 'renderItem',
    value: function renderItem() {
      var item = this.props.item;

      return _react2.default.createElement(
        'div',
        { className: styles.preview },
        item.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          itemType = _props.itemType,
          isDragging = _props.isDragging;

      if (!isDragging) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { style: layerStyles, ref: this.getLayerElement },
        _react2.default.createElement(
          'div',
          { style: this.getItemStyles() },
          this.renderItem(itemType, item)
        )
      );
    }
  }]);
  return SortableItemPreview;
}(_react.Component), _class3.propTypes = {
  currentOffset: _propTypes2.default.shape({
    x: _propTypes2.default.number.isRequired,
    y: _propTypes2.default.number.isRequired
  }),
  isDragging: _propTypes2.default.bool.isRequired,
  item: _propTypes2.default.object,
  itemType: _propTypes2.default.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getLayerElement', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getLayerElement'), _class2.prototype)), _class2)) || _class);
exports.default = SortableItemPreview;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SortableList/SortableItemPreview.js
// module id = 2104
// module chunks = 1